import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const selectableRowVariants = cva(
  "w-full text-left transition-colors hover:bg-panel-raised focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus",
  { variants: { selected: { true: "bg-panel-raised", false: "" } }, defaultVariants: { selected: false } },
);

export interface SelectableRowProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "aria-pressed">, VariantProps<typeof selectableRowVariants> {}

export const SelectableRow = React.forwardRef<HTMLButtonElement, SelectableRowProps>(({ className, selected, type = "button", ...props }, ref) => (
  <button ref={ref} type={type} className={cn(selectableRowVariants({ selected }), className)} aria-pressed={selected === true ? true : undefined} {...props} />
));
SelectableRow.displayName = "SelectableRow";
